var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"embed-responsive embed-responsive-16by9 waiting-screen"},[_c('div',{staticClass:"embed-responsive-item",attrs:{"id":"player"}},[_c('div',{staticClass:"text-wrapper"},[_c('h5',[_vm._v(_vm._s(_vm.$t('this_event_completed')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }